import { Injectable } from '@angular/core';
import { RestAPIService } from '../restAPI/rest-api.service';
import{IssueStage} from 'src/app/services/bug-module/StageType-enum';
import { Observable } from 'rxjs';
import { BugReportDTO } from 'src/app/dtos/BugReportDTO';
import { co } from '@fullcalendar/core/internal-common';
import { colorSets } from '@swimlane/ngx-charts';

@Injectable({
  providedIn: 'root'
})
export class BugModuleService {

  private readonly bugmoduleapi='/api/bugmodule';
  private readonly bugnotifyapi='/notifyall';
  private readonly bugupdateapi='/updateapi';
  private readonly bugupdateapi1='/updatepncomment';
  private readonly getbughistory='/getIssueHistory';
  private readonly getimages='/getImages';
  private readonly getsinglebug='/getSingleBug/';

  constructor(private restApiService: RestAPIService) { }
  addIssue(formData){
    return this.restApiService.post(this.bugmoduleapi,formData);
  }
  getIssues( 
    q?:string,
    status?:string,
    IssueStage?:IssueStage,
    date?:Date, 
    page: number = 0, 
    size: number = 20, 
  ):Observable<any> {
    let queryParams = `?page=${page}&size=${size}`;
    if (q && q.trim()) {
      queryParams += `&q=${encodeURIComponent(q.trim())}`;
    }
    if (status && status.trim()) {
      queryParams += `&status=${status}`;
    }
    if (IssueStage && IssueStage!==null) {
      queryParams += `&issueStage=${IssueStage}`;
    }
    if (date && date!==null) {
      queryParams += `&date=${date}`;
    }
    
    return this.restApiService.get(this.bugmoduleapi+queryParams);
  }

  updateStage(
   updatedIssue: BugReportDTO)
    {
    return this.restApiService.put(this.bugmoduleapi, updatedIssue);
  }
  notifyAll(
    issue:BugReportDTO
  ){
    return this.restApiService.post(this.bugmoduleapi+this.bugnotifyapi,issue);
  }
  updateAdditionalInfo(
    bugModule:BugReportDTO
  ){
    console.log(bugModule);
    return this.restApiService.put(this.bugmoduleapi+this.bugupdateapi,bugModule);
  }
  updatePntCommentsInfo(
    bugModule:BugReportDTO
  ){
    return this.restApiService.put(this.bugmoduleapi+this.bugupdateapi1,bugModule);
  }
  getIssueHistory(
    q?:string,
    year?:number,
    IssueStage?:IssueStage
  ):Observable<any>
  {let queryParams = `?`;
    if (q && q.trim()) {
      queryParams += `&q=${encodeURIComponent(q.trim())}`;
    }
    if (year && year!==null) {
      queryParams += `&year=${year}`;
    }
    if (IssueStage && IssueStage!==null) {
      queryParams += `&issueStage=${IssueStage}`;
    }
    return this.restApiService.get(this.bugmoduleapi+this.getbughistory+queryParams);
  }
  getImages(
    bugId: string
  ):Observable<any>
  {
    let queryParams = `?bugId=${bugId}`;
    return this.restApiService.get(this.bugmoduleapi+this.getimages+queryParams);
  }

  getSingleBug(id:string):Observable<any>{
    return this.restApiService.get(this.bugmoduleapi+this.getsinglebug+`${id}`)
  }

  getUserId(){
    return this.restApiService.get(this.bugmoduleapi+'/getUser');
  }
}
